// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantsBoardColumnHeader-moduleRentalPortalApplicantsBoardColumnHeader__Oj3N8";
var _2 = "RentalPortalApplicantsBoardColumnHeader-moduleskeletonCount__C6ElZ Skeleton-moduleSkeleton__Mlrfv";
var _3 = "RentalPortalApplicantsBoardColumnHeader-modulezeroCount__WR8H4 Counter-modulecounter__yXwqU Counter-moduletable__yR0uS";
export { _1 as "RentalPortalApplicantsBoardColumnHeader", _2 as "skeletonCount", _3 as "zeroCount" }
